import { defineMessages } from "react-intl";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const messages: { [key: string]: any } = defineMessages({
  dialogTitle: {
    id: "dialog.modifyMeetingParticipants.title",
    defaultMessage: "Update meeting participants",
    description: "titel for update meeting participants dialog ",
  },
  submitButtonLabel: {
    id: "dialog.modifyMeetingParticipants.button.submit",
    defaultMessage: "Update Meeting",
    description: "Submit label for updating meeting participants",
  },
  cancelButtonLabel: {
    id: "dialog.modifyMeetingParticipants.button.cancel",
    defaultMessage: "Cancel",
    description: "Cancel label for cancel update of meeting participants",
  },
  success: {
    id: "dialog.modifyMeetingParticipants.success",
    defaultMessage: "Meeting participants was updated",
    description: "Success message when meeting has been updated",
  },
  generalError: {
    id: "dialog.modifyMeetingParticipants.generalError",
    defaultMessage: "Something went wrong",
    description: "Text shown in snack bar when it fails to update a meeting",
  },
});
